import React, { useCallback, useEffect, useRef, useState } from 'react';
import classes from './ShippingLines.module.scss';
import EntityBox from '../EntityBox/EntityBox';
import get from '../../../../services/axios/get';
import del from '../../../../services/axios/delete';
import patch from '../../../../services/axios/patch';
import { useAppDispatch } from '../../../../store/hooks';
import { customAlert } from '../../../../store/actions/alert';
import post from '../../../../services/axios/post';

interface ShippingLineProps { };

const ShippingLines: React.FC<ShippingLineProps> = (props) => {
  const dispatch = useAppDispatch()
  const isMounted = useRef(true);
  const [shippingLines, setShippingLine] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBroken, setIsBroken] = useState(false);

  const createNewShippingLine = (shippingLine: { alias: string }) => {
    post(
      '/shipping-line',
      { alias: shippingLine.alias, isDischarge: false },
      () => {
        if (isMounted) {
          setIsLoading(true);
          getShippingLines();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  }

  const deleteShippingLine = (shippingLineId: string) => {
    del(
      `/shipping-line/${shippingLineId}`,
      {},
      () => {
        if (isMounted) {
          setIsLoading(true);
          getShippingLines();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  };

  const editShippingLine = (shippingLineId: string, shippingLineName: string) => {
    patch(
      `/shipping-line/${shippingLineId}`,
      { alias: shippingLineName },
      () => {
        if (isMounted) {
          setIsLoading(true);
          getShippingLines();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  };

  const getShippingLines = useCallback(
    () => {
      get(
        '/shipping-line',
        { isDischarge: false },
        (res) => {
          if (isMounted) {
            setShippingLine(res.data);
            setIsLoading(false)
          }
        },
        () => {
          setIsBroken(true);
          setIsLoading(false)
        });
    },
    []
  );

  useEffect(() => {
    getShippingLines();

    return () => {
      isMounted.current = false;
    }
  }, [getShippingLines])

  return (
    <>
      <EntityBox
        entityName='shipping line'
        header='Shipping Lines'
        isLoading={isLoading}
        entities={shippingLines}
        isBroken={isBroken}
        delete={deleteShippingLine}
        edit={editShippingLine}
        createNewEntity={createNewShippingLine}
      />
    </>

  );
};

export default ShippingLines;